import BackofficeController from "backoffice_controller";

export default class extends BackofficeController {
  static targets = ["imageSelector", "imageContainer", "imagePlaceholder"];

  connect() {}

  chooseImage(event) {
    event.preventDefault();
    this.imageSelectorTarget.click();
  }

  handlePreview(event) {
    let reader = new FileReader();
    const imageElement = this.imageContainerTarget.getElementsByTagName("img")[0];
    reader.onload = () => {
      const previewImageSrc = reader.result;
      if (imageElement) {
        imageElement.src = previewImageSrc;
      } else {
        this.imagePlaceholderTarget.classList.add("d-none");
        this.imageContainerTarget.insertAdjacentHTML("afterbegin", `<img src="${previewImageSrc}">`);
      }
    };
    reader.readAsDataURL(event.target.files[0]);
  }
}
